<template>
  <div class="">
    <v-container class="py-0">
      <transition name="fade" mode="out-in" appear>
        <PageTitle class="d-block d-sm-none">Properties</PageTitle>
      </transition>

      <transition name="slide-left-fade" mode="out-in" appear>
        <v-tabs
          v-model="tab"
          class="mt-5 mt-sm-1"
          color="tabColor"
          slider-color="tabColor"
          center-active
          background-color="tertiary"
          show-arrows
          height="55"
        >
          <v-tab ripple>
            <span class="d-md-none">Active</span>
            <span class="d-none d-md-block">Active tenancies</span>
          </v-tab>
          <v-tab ripple>
            Rent collected 
          </v-tab>
          <v-tab ripple>
            <span class="">No owner</span>
            <!-- <span class="d-none d-md-block">Without owner </span> -->
          </v-tab>
          <v-tab ripple>
            <span class="">No tenants</span>
            <!-- <span class="d-none d-md-block">Missing tenants</span> -->
          </v-tab>
          <v-tab ripple>
            <span class="">Not collected</span>
            <!-- <span class="d-none d-md-block">Rent not collected</span> -->
          </v-tab>
          <v-tab ripple>
            <span class="">New</span>
            <!-- <span class="d-none d-md-block">New tenancies</span> -->
          </v-tab>
          <v-tab ripple>
            <span class="">Historic</span>
            <!-- <span class="d-none d-md-block">New tenancies</span> -->
          </v-tab>
          <v-spacer></v-spacer>
          <span class="d-none d-sm-block">
            <PageTitle>Properties</PageTitle>
          </span>
        </v-tabs>
      </transition>

      <transition name="slide-fade" mode="out-in" appear>
        <div>
          <v-tabs-items v-model="tab" class="pt-2 tertiary">
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesManagedRecords"
                :headers="headers"
                msg="managed"
                :isLoading="loading.managed"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesRentCollectedRecords"
                :headers="headers"
                msg="rent collected"
                :isLoading="loading.rentCollected"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item> 
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesWithoutOwnerRecords"
                :headers="headers"
                msg="ownerless"
                :isLoading="loading.ownerless"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>  
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesWithoutTenantsRecords"
                :headers="headers"
                msg="without tenants"
                :isLoading="loading.tenantless"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>  
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesNotManagedRecords"
                :headers="headers"
                msg="not managed"
                :isLoading="loading.notManaged"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesNewTenanciesRecords"
                :headers="headers"
                msg="new tenancies"
                :isLoading="loading.newTenancies"
                @paginate="handlePaginationUpdate"
              />     
            </v-tab-item>
            <v-tab-item>
              <PropertyRecordsTables
                :tableData="propertiesHistoricRecords"
                :headers="headers"
                msg="historic"
                :isLoading="loading.historic"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>      
          </v-tabs-items>
        </div>
      </transition>

      <v-row>
        <v-col cols="12">
          <v-expansion-panels multiple class="mt-8">
            <v-expansion-panel>
              <v-expansion-panel-header ripple class="secondary lighten-3 white--text">
                <div class="d-flex align-center justify-start">
                  <!-- <v-icon class="mr-3" color="white">mdi-home</v-icon> -->
                  <v-icon class="mr-3" color="white">mdi-pencil</v-icon>
                  Edit property
                </div>
                <template v-slot:actions>
                  <v-icon color="white">$expand</v-icon>
                </template>
                </v-expansion-panel-header>
              <v-expansion-panel-content>
                <EditProperty />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PropertyRecordsTables from  '../components/Properties/PropertyRecordsTable.vue'
import EditProperty from '@/components/Edits/EditProperty.vue'
import PageTitle from '@/components/Slots/PageTitle.vue';

export default {
  components: {
    PropertyRecordsTables,
    EditProperty,
    PageTitle
  },
  data() {
    return {
      tab: null,
      icon: 'mdi-home',
      managed: true,
      notManaged: true,
      withoutOwner: true,
      rentCollected: true,
      withoutTenants: true,
      newTenancies: true,
      historicTenancies: true,
      headers: [
      {
        text: 'Main Tenant',
        align: 'left',
        value: 'HeadTenant',
      },
      // { text: 'Landlord', value: 'Landlord' },
      { text: 'Landlord/Address', value: 'PropertyAddress' },
      { text: 'Rent', value: 'RentPerCalendarMonth' },
      { text: 'Type', value: 'ServiceType' },
      { text: 'Tenancy', value: 'TenancyState' },
      // { text: 'Support', value: 'Message' },
      { text: '', value: 'actions', align: 'end' },

    ],
    pagination: {
      managed: { page: 1, itemsPerPage: 10 },
      ownerless: { page: 1, itemsPerPage: 10 },
      rentCollected: { page: 1, itemsPerPage: 10 },
      tenantless: { page: 1, itemsPerPage: 10 },
      notManaged: { page: 1, itemsPerPage: 10 },
      newTenancies: { page: 1, itemsPerPage: 10 },
      historic: { page: 1, itemsPerPage: 10 }
    },
    loadedTabs: {
      managed: false,
      rentCollected: false,
      ownerless: false,
      tenantless: false,
      notManaged: false,
      newTenancies: false,
      historic: false
    }
    }
  },
  created() {
    // Only load the first tab on initial load
    this.loadManagedProperties()
    this.loadedTabs.managed = true
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'managed',
        1: 'rentCollected',
        2: 'ownerless',
        3: 'tenantless',
        4: 'notManaged',
        5: 'newTenancies',
        6: 'historic'
      }
      
      const tabType = tabMap[newTab]
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadTabData(tabType)
        this.loadedTabs[tabType] = true
      }
    }
  },
  computed: {
    ...mapState({
      propertiesManagedRecords: state => ({
        Data: state.PropertiesRecords.propertiesManagedRecords,
        Count: state.PropertiesRecords.totalCount.managed
      }),
      propertiesRentCollectedRecords: state => ({
        Data: state.PropertiesRecords.propertiesRentCollectedRecords,
        Count: state.PropertiesRecords.totalCount.rentCollected
      }),
      propertiesWithoutOwnerRecords: state => ({
        Data: state.PropertiesRecords.propertiesWithoutOwnerRecords,
        Count: state.PropertiesRecords.totalCount.ownerless
      }), 
      propertiesWithoutTenantsRecords: state => ({
        Data: state.PropertiesRecords.propertiesWithoutTenantsRecords,
        Count: state.PropertiesRecords.totalCount.tenantless
      }),
      propertiesNotManagedRecords: state => ({
        Data: state.PropertiesRecords.propertiesNotManagedRecords,
        Count: state.PropertiesRecords.totalCount.notManaged
      }),
      propertiesNewTenanciesRecords: state => ({
        Data: state.PropertiesRecords.propertiesNewTenanciesRecords,
        Count: state.PropertiesRecords.totalCount.newTenancies
      }),
      propertiesHistoricRecords: state => ({
        Data: state.PropertiesRecords.propertiesHistoricRecords,
        Count: state.PropertiesRecords.totalCount.historic
      }),
      // Loading states
      loading: state => state.PropertiesRecords.loading
    })
  },
  methods: {
    async loadPropertyData() {
      await Promise.all([
        this.loadManagedProperties(this.pagination.managed.page),
        this.loadRentCollectedProperties(this.pagination.rentCollected.page),
        this.loadOwnerlessProperties(this.pagination.ownerless.page),
        this.loadTenantlessProperties(this.pagination.tenantless.page),
        this.loadNotManagedProperties(this.pagination.notManaged.page),
        this.loadNewTenanciesProperties(this.pagination.newTenancies.page),
        this.loadHistoricProperties(this.pagination.historic.page)
      ])
    },
    async loadTabData(tabType) {
      switch(tabType) {
        case 'managed':
          await this.loadManagedProperties()
          break
        case 'rentCollected':
          await this.loadRentCollectedProperties()
          break
        case 'ownerless':
          await this.loadOwnerlessProperties()
          break
        case 'tenantless':
          await this.loadTenantlessProperties()
          break
        case 'notManaged':
          await this.loadNotManagedProperties()
          break
        case 'newTenancies':
          await this.loadNewTenanciesProperties()
          break
        case 'historic':
          await this.loadHistoricProperties()
          break
      }
    },
    async loadManagedProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.managed.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.managed.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesManagedRecords', {
        offset,
        limit: this.pagination.managed.itemsPerPage,
        forceRefresh: itemsPerPage !== null, // Force refresh when items per page changes
        ...filters
      })
      this.pagination.managed.page = page
    },
    async loadRentCollectedProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.rentCollected.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.rentCollected.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesRentCollectedRecords', {
        offset,
        limit: this.pagination.rentCollected.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.rentCollected.page = page
    },
    async loadOwnerlessProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.ownerless.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.ownerless.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesOwnerlessRecords', {
        offset,
        limit: this.pagination.ownerless.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.ownerless.page = page
    },
    async loadTenantlessProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.tenantless.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.tenantless.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesWithoutTenantsRecords', {
        offset,
        limit: this.pagination.tenantless.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.tenantless.page = page
    },
    async loadNotManagedProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.notManaged.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.notManaged.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesNotManagedRecords', {
        offset,
        limit: this.pagination.notManaged.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.notManaged.page = page
    },
    async loadNewTenanciesProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.newTenancies.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.newTenancies.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesNewTenanciesRecords', {
        offset,
        limit: this.pagination.newTenancies.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.newTenancies.page = page
    },
    async loadHistoricProperties(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.historic.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.historic.itemsPerPage
      await this.$store.dispatch('PropertiesRecords/getPropertiesHistoricTenanciesRecords', {
        offset,
        limit: this.pagination.historic.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.historic.page = page
    },
    handlePaginationUpdate(type, page, itemsPerPage, filters = {}) {
      // Mark tab as loaded when user interacts with pagination
      if (!this.loadedTabs[type]) {
        this.loadedTabs[type] = true
      }
      
      // Update pagination state immediately for responsive UI
      this.pagination[type].page = page
      if (itemsPerPage && itemsPerPage !== this.pagination[type].itemsPerPage) {
        this.pagination[type].itemsPerPage = itemsPerPage
      }
      
      switch(type) {
        case 'managed':
          this.loadManagedProperties(page, itemsPerPage, filters)
          break
        case 'rentCollected':
          this.loadRentCollectedProperties(page, itemsPerPage, filters)
          break
        case 'ownerless':
          this.loadOwnerlessProperties(page, itemsPerPage, filters)
          break
        case 'tenantless':
          this.loadTenantlessProperties(page, itemsPerPage, filters)
          break
        case 'notManaged':
          this.loadNotManagedProperties(page, itemsPerPage, filters)
          break
        case 'newTenancies':
          this.loadNewTenanciesProperties(page, itemsPerPage, filters)
          break
        case 'historic':
          this.loadHistoricProperties(page, itemsPerPage, filters)
          break
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
